import { render, staticRenderFns } from "./BaseBankAccountTest.vue?vue&type=template&id=1ec492ea&scoped=true&"
import script from "./BaseBankAccountTest.vue?vue&type=script&lang=js&"
export * from "./BaseBankAccountTest.vue?vue&type=script&lang=js&"
import style0 from "./BaseBankAccountTest.vue?vue&type=style&index=0&id=1ec492ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec492ea",
  null
  
)

export default component.exports